module.exports = __webpack_public_path__ + "img/255-ebb561.png";